import { useTranslationStore } from "@storesCommon/TranslationStore"

var translateMixin = {

	methods: {
		// Example: properties = { manuscriptCount: bulk_update.length }
		translate(string, properties ) {
			const TranslationStore = useTranslationStore();

			return TranslationStore.translate(string, properties);
		},


		countriesList() {
			const TranslationStore = useTranslationStore();

			return TranslationStore.countriesList();
		}
	},
};

export { translateMixin };
